"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createContext = createContext;
var _index = require("../index");
function createContext(dom, paneRegistry, store, logic) {
  return {
    dom,
    getOutliner: _index.getOutliner,
    session: {
      paneRegistry,
      store,
      logic
    }
  };
}
//# sourceMappingURL=context.js.map